import React from 'react';
import { SxProps } from '@mui/material';
import { Button } from '../../../button';
import { Stack } from '../../../stack';

import { AppTheme } from '../../../../theme';
import { ButtonProps } from '../../../button/model';

export interface AppModalAction {
  title: string;
  callback?: () => void | Promise<void>;
  color?: ButtonProps['color'];
  variant?: ButtonProps['variant'];
  buttonProps?: Omit<ButtonProps, 'onClick' | 'children' | 'color' | 'variant'>;
}

export interface ModalActionsProps {
  actions: AppModalAction[];
  sx?: SxProps<AppTheme>;
}

export const ModalActions: React.FC<ModalActionsProps> = ({ actions, sx }) => {
  return (
    <Stack direction="row" justifyContent="center" mt={2} px={{ xs: 2.5, md: 0 }} spacing={1} sx={sx}>
      {actions?.map(({ title: actionTitle, callback, color, variant, buttonProps }) => (
        <Button color={color} key={actionTitle} onClick={callback} variant={variant} {...buttonProps}>
          {actionTitle}
        </Button>
      ))}
    </Stack>
  );
};
